<template>
  <div class="comp-xl-find-obj" v-if="objId">
    <!-- @search="handleSearch" :filter-option="false" -->
    <jw-select :loading="loading" v-model="selectVal" :disabled="disabled" :options="options" allow-search :placeholder="props.placeholder ? $t(props.placeholder) : ''" :multiple="multiple" @change="changeHandle" :virtual-list-props="{ height: 200 }" allow-clear @clear="clearHandle" style="width: 262px">
      <!-- <jw-option v-for="item in options" :key="item.value" :title="item.label">{{ item.label }}</jw-option> -->
      <template #option="{ data }">
        <span :title="data.label">{{ data.label }}</span>
      </template>
    </jw-select>
    <jw-button :disabled="disabled" @click="openDialog">
      <template #icon>
        <icon-plus />
      </template>
    </jw-button>
  </div>
  <div class="comp-xl-find-obj" v-else>{{ $t('对象Id不能为空') }}</div>
  <!-- 弹窗打开 S -->
  <jw-modal v-model:visible="visible" width="70%" title-align="start" :on-before-ok="handleOk" @cancel="cancelModal" unmount-on-close :mask-closable="false">
    <template #title> {{ $t('选择关联') }}{{ objectName || $t('对象') }} </template>

    <jw-space direction="vertical" fill>
      <xl-search :searchObj="searchObj" @cb="getSerachData"></xl-search>
      <xl-table v-on="tPropsEvent" v-bind="tProps" ref="xlUserTable" :columns="columns" v-model:selectedKeys="ids" @select="xlTableSelect" @selectAll="xlUseSelectAll">
        <!-- 线索相关slot S -->

        <!-- 跟进建议 插槽 -->
        <template #intentionality="{ record }">
          <xl-dot :title="record?.custom.intentionality" :color="colors[3]" v-if="record?.custom?.intentionality === '待处理'">
            {{ $t(record.custom.intentionality) }}
          </xl-dot>
          <xl-dot :title="record?.custom.intentionality" :color="colors[0]" v-else-if="record?.custom?.intentionality === '建议转化'">
            {{ $t(record.custom.intentionality) }}
          </xl-dot>
          <xl-dot :title="record?.custom.intentionality" :color="colors[1]" v-else-if="record?.custom?.intentionality === '建议无效'">
            {{ $t(record.custom.intentionality) }}
          </xl-dot>
          <xl-dot :title="record?.custom.intentionality" :color="colors[2]" v-else-if="record?.custom?.intentionality === '待定'">
            {{ $t(record.custom.intentionality) }}
          </xl-dot>
          <xl-dot :title="record?.custom.intentionality" :color="colors[4]" v-else-if="record?.custom?.intentionality">
            {{ $t(record.custom.intentionality) }}
          </xl-dot>
          <template v-else>-</template>
        </template>
        <!-- 跟进人插槽 -->
        <template #followUserId="{ record }">
          <xl-avatar v-if="record.followUserId" :avatar="{ name: record?.followUserName || '', url: record?.followUserAvatar, id: record?.userId }" :size="22" />
          <template v-else> - </template>
        </template>
        <!-- 客户级别 -->
        <template #customerLevel="{ record }">
          <jw-tag bordered color="cyan" v-if="record?.custom?.customerLevel === 'A类'">
            {{ $t(record.custom.customerLevel) }}
          </jw-tag>
          <jw-tag bordered color="arcoblue" v-else-if="record?.custom?.customerLevel === 'B类'">
            {{ $t(record.custom.customerLevel) }}
          </jw-tag>
          <jw-tag bordered color="pinkpurple" v-else-if="record?.custom?.customerLevel === 'C类'">
            {{ $t(record.custom.customerLevel) }}
          </jw-tag>
          <template v-else>-</template>
        </template>
        <!-- 创建人插槽 -->
        <template #createUser="{ record }">
          <xl-avatar v-if="record.createUserShowVo" :avatar="{ name: record?.createUserShowVo.userName || '', url: record?.createUserShowVo.avatar, id: record?.createUserShowVo.userId }" :size="22" />
          <xl-avatar v-else-if="record.addUserInfo" :avatar="{ name: record?.addUserInfo.userName || '', url: record?.addUserInfo.avatar, id: record?.addUserInfo.userId }" :size="22" />
          <xl-avatar v-else-if="record.createUser" :avatar="{ name: record?.createUserName || '', url: record?.createUserAvatar, id: record?.createUser }" :size="22" />
          <template v-else>-</template>
        </template>
        <!-- 最后跟进人插槽 -->
        <template #lastUpdateUser="{ record }">
          <xl-avatar v-if="record.lastUpdateUser" :avatar="{ name: record?.lastUpdateUserName || '', url: record?.lastUpdateUserAvatar, id: record?.lastUpdateUser }" :size="22" />
          <template v-else>-</template>
        </template>
        <!-- 重点客户插槽 -->
        <template #important="{ record }">
          <jw-tag v-if="record?.important" color="magenta" size="small">{{ $t('重点') }}</jw-tag>
          <template v-else>-</template>
        </template>
        <!-- 最后跟进内容 -->
        <template #lastFollowContent="{ record }">
          <template v-if="record?.lastFollowContent">{{ tools.stripMarkdown(record?.lastFollowContent) }}</template>
          <template v-else>-</template>
        </template>

        <!-- 线索相关slot E -->

        <!-- 客户相关slot S -->

        <template #customerName="{ record }">
          {{ record.customerName || '-' }}
        </template>

        <!-- 关联工商信息 qccId-->
        <template #qccId="{ record }">
          <jw-tag :color="record.qccId ? 'green' : 'pink'">{{ record.qccId ? $t('是') : $t('否') }}</jw-tag>
          <!-- <div class="qccId-tr">
            <span class="qccId-status">{{ record.qccId ? $t('是') : $t('否') }}</span>
            <jw-tooltip :content="$t('tips.customerIsRequired')" position="rt" mini>
              <icon-exclamation-circle-fill size="20" style="color: orange; cursor: pointer" v-if="!record.qccId" />
            </jw-tooltip>
          </div> -->
        </template>
        <!-- 负责人插槽 -->
        <template #chargePerson="{ record }">
          <xl-avatar v-if="record.chargeUserInfo" :avatar="{ name: record?.chargeUserInfo?.userName || '', url: record?.chargeUserInfo?.avatar, id: record?.chargeUserInfo?.id }" :size="22" />
          <xl-avatar v-else-if="record.chargePersonShowVo" :avatar="{ name: record?.chargePersonShowVo?.userName || '', url: record?.chargePersonShowVo?.avatar, id: record?.chargePersonShowVo?.id }" :size="22" />
          <xl-avatar v-else-if="record.chargePerson" :avatar="{ name: record?.chargePersonName || '', url: record?.chargePersonAvatar, id: record?.chargePerson }" :size="22" />
          <template v-else>-</template>
        </template>
        <!-- 客户级别 -->
        <template #customer_level="{ record }">
          <jw-tag bordered color="cyan" v-if="record?.custom?.customer_level === 'A类'">
            {{ $t(record.custom.customer_level) }}
          </jw-tag>
          <jw-tag bordered color="arcoblue" v-else-if="record?.custom?.customer_level === 'B类'">
            {{ $t(record.custom.customer_level) }}
          </jw-tag>
          <jw-tag bordered color="pinkpurple" v-else-if="record?.custom?.customer_level === 'C类'">
            {{ $t(record.custom.customer_level) }}
          </jw-tag>
          <template v-else>-</template>
        </template>
        <!-- 联系人所在部门-->
        <template #department="{ record }">
          <span>{{ record.department ? record.department : '-' }}</span>
        </template>
        <!-- 职位-->
        <template #jobTitle="{ record }">
          <span>{{ record.jobTitle ? record.jobTitle : '-' }}</span>
        </template>
        <!-- kdm-->
        <template #kdm="{ record }">
          <span>{{ record.kdm == '0' ? $t('是') : record.kdm == '1' ? $t('否') : record.kdm == '2' ? $t('老板委托调研人') : record.kdm == '3' ? $t('暂不确定') : '-' }}</span>
        </template>
        <!-- 成交状态 -->
        <template #isDealt="{ record }">
          <jw-tag v-if="record.isDealt || record.isDealt === 0" :color="record.isDealt == 1 ? 'green' : 'pinkpurple'" size="small">{{ $t(clientState?.[record.isDealt]) }}</jw-tag>
          <template v-else> - </template>
        </template>
        <!-- 最后更新人插槽 -->
        <template #updateUser="{ record }">
          <xl-avatar v-if="record.updateUserShowVo" :avatar="{ name: record?.updateUserShowVo.userName || '', url: record?.updateUserShowVo.avatar, id: record?.updateUserShowVo.userId }" :size="22" />
          <xl-avatar v-else-if="record.updateUserInfo" :avatar="{ name: record?.updateUserInfo.userName || '', url: record?.updateUserInfo.avatar, id: record?.updateUserInfo.userId }" :size="22" />
          <xl-avatar v-else-if="record.updateUser" :avatar="{ name: record?.updateUserName || '', url: record?.updateUserAvatar, id: record?.updateUser }" :size="22" />
          <template v-else>-</template>
        </template>
        <!-- 官网链接 -->
        <template #customer_web_url="{ record }">
          <jw-link v-if="record?.custom?.customer_web_url" :href="record?.custom?.customer_web_url" target="_blank">{{ $t('查看') }}</jw-link>
          <template v-else>-</template>
        </template>
        <!-- 客户相关slot E -->

        <!-- 商机相关slot S -->

        <!-- 商机阶段-->
        <template #opportunityStage="{ record }">
          <jw-tag v-if="record.opportunityStage" :color="record.opportunityStage == '赢单' ? 'green' : record.opportunityStage == '丢单' ? 'red' : record.opportunityStage == '无效' ? 'gray' : 'purple'" size="small">{{ record.opportunityStage }}</jw-tag>
          <template v-else>-</template>
        </template>
        <!-- 商机金额-->
        <template #opportunityAmount="{ record }">
          <span v-if="record?.opportunityAmount">{{ tools.getPrice(record?.opportunityAmount) }}</span>
          <template v-else>-</template>
        </template>
        <!-- 官网链接 -->
        <template #ARR_APAAS="{ record }">
          <span v-if="record?.custom?.ARR_APAAS">{{ record?.custom?.ARR_APAAS }}</span>
          <template v-else>-</template>
        </template>
        <!-- 产品apaas -->
        <template #product_apaas="{ record }">
          <template v-if="record?.custom?.product_apaas">
            <jw-tooltip position="right" mini>
              <template #content>
                <p v-for="(item, index) in record?.custom?.product_apaas.split(',')" :key="index">
                  {{ item }}
                </p>
              </template>
              <div class="product-apaas-list">
                <span v-for="(item, index) in record?.custom?.product_apaas.split(',')" :key="index">
                  <jw-tag bordered style="margin-right: 5px" :color="tagColors[index]">
                    {{ item }}
                  </jw-tag>
                </span>
              </div>
            </jw-tooltip>
          </template>
          <template v-else>-</template>
        </template>
        <!-- 商机相关slot E -->

        <!-- 产品相关slot S -->

        <!-- 产品相关slot E -->

        <!-- 报价单slot S -->
        <!-- 负责人插槽 -->

        <!-- 报价单金额 -->
        <template #amount="{ record }">
          {{ record?.amount }}
          {{ tools.getPrice(record?.amount)?.toFixed(2) || '-' }}
        </template>

        <!-- 链接 -->
        <template #urlInfo="{ record }">
          <jw-link v-if="record?.urlInfo" :href="record?.urlInfo" target="_blank">{{ $t('查看') }}</jw-link>
          <template v-else>-</template>
        </template>

        <!-- 报价单slot E -->

        <!-- 合同slot S -->
        <!--生命状态 -->
        <template #status="{ record }">
          <xl-status :status="record.status" :statusOrigin="record.statusOrigin"></xl-status>
        </template>
        <!-- 账期  -->
        <template #billPeriod="{ record }">
          <span v-if="record?.billPeriod || record?.billPeriod == 0">{{ record?.billPeriod + $t('天') }}</span>
          <template v-else>-</template>
        </template>
        <!-- 合同slot E -->

        <template #customerId="{ record }">
          {{ record.customer?.label || record.customerId?.label || '-' }}
        </template>
        <template #opportunityId="{ record }">
          {{ record.opportunity?.label || record.opportunityId?.label || '-' }}
        </template>
        <template #priceSheetId="{ record }">
          {{ record.priceSheet?.label || record.priceSheetId?.label || '-' }}
        </template>
      </xl-table>
    </jw-space>
  </jw-modal>
  <!-- 弹窗打开 E -->
</template>

<script setup>
import { ref, h, reactive, onMounted, watch } from 'vue';
import { Message } from '@arco-design/web-vue';
import { publicService, setService } from '@/api/';
import { tools } from '@/utils/tools';
import { clientState } from '@/utils/const';
import useFields from '@/hooks/fields';
import useLoading from '@/hooks/loading';
import useXlTable from '@/hooks/xl-table';
import { watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const { loading, setLoading } = useLoading(false);
const props = defineProps({
  multiple: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  },
  modelValue: {
    type: [String, Number, Array]
  },
  qccId: {
    type: [String, Number]
  },
  customerId: {
    type: [String, Number]
  },
  selectedItem: {
    type: [Object, Array]
  },
  placeholder: {
    type: String,
    default: '请选择/输入值搜索'
  },
  objId: {
    type: Number,
    require: true,
    validator(value) {
      // The value must match one of these number
      return [1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13].includes(value) || value >= 200;
    }
  }
});
const emits = defineEmits(['update:modelValue', 'update:selectedItem', 'change']);

const colors = ref(['#37b41a', 'var(--color-text-2)', 'gold', 'orange', 'gray']);
const tagColors = ref(['red', 'orangered', 'orange', 'gold', 'lime', 'green', 'cyan', 'blue', 'arcoblue', 'purple', 'pinkpurple', 'magenta']); //产品apass颜色

const options = ref([]);
const selectVal = ref(props.multiple ? [] : '');
// 搜索
const searchObj = {
  list: [
    {
      type: 'input',
      name: 'search',
      placeholder: props.placeholder || t('请输入名称')
    }
  ]
};
// apiObj
const objEnums = reactive({
  1: 'companyName',
  2: 'customerName',
  3: 'opportunityName',
  4: 'productName',
  6: 'priceSheetCode',
  7: 'fieldName',
  8: 'code',
  9: 'fieldName',
  10: 'code',
  11: 'code',
  12: 'salesNo'
});
// const objText = ref({
//   1: '线索',
//   2: '客户',
//   3: '商机',
//   4: '产品',
//   6: '报价单',
//   7: '报价单产品',
//   8: '合同',
//   9: '合同产品',
//   10: '订单',
//   11: '订单产品',
//   12: '售后'
// });

// 其他列表
const handleSearch = async (value) => {
  options.value = [];
  try {
    setLoading(true);
    const id = props.objId;
    const n = objEnums[id] || 'name';
    // 如果是产品 ，则单独处理
    if (id == '4' || id >= 200) {
      const params = {
        entity: id,
        pageSize: 9999,
        apiIndex: id + Math.random(),
        conditions: []
      };
      if (value) {
        params.conditions = [{ fieldType: 0, fieldValue: value, type: 1, fieldKey: n }];
      } else {
        params.conditions = [];
      }
      let url = publicService.getListByEntity(params);
      if (id >= 200) {
        //兼容自定义
        url = publicService.getListByEntityId(params);
      }
      const json = await url;
      options.value = json.result?.records.map((el) => ({ ...el, label: el[n], value: el.id }));
    } else {
      const params = {
        type: props.objId
      };
      if (props.objId == 2 && props.qccId) {
        params.qccId = props.qccId;
      }
      // 如果是有customerId的，这调用新api
      let defApi = 'getSimpleListByEntity';
      const defParams = { apiIndex: id + Math.random(), ...params, id: props?.customerId || undefined };
      if (props.objId == 3 && props?.customerId) {
        defApi = 'getOpportunityByCustomerId';
      }
      if (props.objId == 6 && props?.customerId) {
        defApi = 'getPriceSheetByCustomerId';
      }
      if (props.objId == 8 && props?.customerId) {
        defApi = 'getContractByCustomerId';
      }
      const json = await publicService[defApi](defParams);
      options.value = json.result;
    }
    setLoading(false);
    // 如果有值，则赋值；
    if (props.modelValue) {
      selectVal.value = props.multiple ? props.modelValue?.map((el) => Number(el) || []) : Number(props.modelValue) || '';
      if (props.multiple) {
        const it = options.value
          .filter((el) => selectVal.value?.find((ele) => ele === el))
          .map((el) => {
            el[`_name`] = el.label;
            return el;
          });
        emits('update:selectedItem', it);
      } else {
        const it = options.value.find((el) => el.value === selectVal.value);
        if (it) {
          it[`_name`] = it.label;
        }
        emits('update:selectedItem', it);
      }
    }
  } catch (e) {
    options.value = [];
    setLoading(false);
    // console.log(405, e);
    // e?.message !== 'canceled' && Message.error(e?.message || e?.statusText || '获取数据失败');
  }
};

// select事件
const changeHandle = (v) => {
  emits('update:modelValue', props.multiple ? v?.filter((v) => v !== '') : v);
  let item = options.value.filter((el) => (props.multiple ? v.indexOf(el.value) > -1 : v === el.value));
  item = item.map((el) => {
    el[`_name`] = el.label;
    return el;
  });
  emits('change', v, item);
  console.log(267, v, item, options.value);
  emits('update:selectedItem', props.multiple ? item : item?.[0]);
};

// 弹窗
const visible = ref(false);
const tableLoading = ref(false);
const columns = ref([]);

// 表格表头数据字段
const { enableList, getFields, getFieldLabel } = useFields();
const getColumns = (fields) => {
  const fieldList = fields?.filter((i) => ['parentCustomerId', 'calendarId', 'callId', 'recordId'].indexOf(i.fieldKey) === -1);
  console.log(116, fieldList);
  return fieldList?.map((item) => {
    let tmp = {};
    const k = item.fieldKey;
    const render = ({ record }) => {
      let fieldKey = record[k];
      if (item.type == 2) {
        fieldKey = record?.['custom']?.[k];
      }
      if (fieldKey || fieldKey === 0) {
        if (item.fieldType === 9) {
          if (fieldKey && fieldKey !== '{}') {
            return Object.values(JSON.parse(fieldKey))?.join('/');
          } else {
            return '-';
          }
        } else if (item.fieldType === 6) {
          if (fieldKey instanceof Array) {
            // console.log('查看人员头像303', fieldKey);
            return fieldKey?.map((v) => v.name)?.join(',');
          } else {
            return '-';
          }
        } else if ([2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
          // console.log(366, item?.fieldExtObj, fieldKey, item?.fieldExtObj[fieldKey]?.label);
          return getFieldLabel(fieldKey, item.fieldExt, item.fieldType);
        } else if (item.fieldType === 11) {
          return h(
            'a',
            {
              style: {
                color: '#165dff',
                cursor: 'pointer'
              },
              href: fieldKey,
              target: '_blank'
            },
            t('查看')
          );
        } else if (item.fieldType === 12) {
          return fieldKey?.label || '-';
        } else if (item.fieldType === 23) {
          return fieldKey ? tools.getPercentage(fieldKey, JSON.parse(item?.fieldExt)?.numberFormat || 2) + '%' : '-';
        } else if (item.fieldType === 24) {
          //计算类型
          if (item?.fieldExt && typeof JSON.parse(item?.fieldExt) == 'object') {
            if (JSON.parse(item.fieldExt).type == 6) {
              //金额类型
              return (fieldKey && tools.getPriceShow(fieldKey, 2)) || '-';
            } else {
              return fieldKey ?? '-';
            }
          } else {
            return fieldKey ?? '-';
          }
        } else if (item.fieldType === 16) {
          if (item.fieldExt) {
            return fieldKey && Number(fieldKey) ? tools.getPrice(fieldKey, item?.fieldExt)?.toFixed(item?.fieldExt) : '-';
          } else {
            return fieldKey && Number(fieldKey) ? tools.getPrice(fieldKey) : '-';
          }
        } else {
          return fieldKey?.label ?? fieldKey?.value ?? fieldKey ?? '-';
        }
      } else {
        return '-';
      }
    };
    const colType = {
      title: item.fieldName,
      dataIndex: k,
      ellipsis: true,
      tooltip: true
    };
    const width = item.fieldName.length <= 5 ? 120 : item.fieldName.length * 30;
    // if (item.type === 1 || item.type == 2) {
    const publicName = ['lastFollowContent ', 'followUserId', 'createUser', 'updateUser', 'lastUpdateUser', 'customerId', 'opportunityId'];
    const leadsNameList = [...publicName].concat('lastFollowContent ', 'followUserId', 'createUser', 'updateUser', 'intentionality', 'lastUpdateUser', 'customerLevel', 'important', 'lastFollowContent');
    const clientNameList = [...publicName].concat('customer_level', 'important', 'lastFollowContent ', 'followUserId', 'createUser', 'updateUser', 'customer_web_url', 'chargePerson', 'qccId', 'intentionality ', 'department', 'jobTitle', 'kdm', 'isDealt');
    const opNameList = [...publicName].concat('ARR_APAAS', 'status', 'lastFollowContent ', 'followUserId', 'createUser', 'updateUser', 'chargePerson', 'intentionality', 'product_apaas', 'opportunityAmount');
    const prdNameList = [...publicName].concat('chargePerson', 'createUser', 'urlInfo', 'amount');
    const psNameList = [...publicName].concat('chargePerson', 'status', 'billPeriod');
    const contractNameList = [...publicName].concat('chargePerson', 'priceSheet', 'status', 'billPeriod');
    const returnOrderNameList = 'status'; //退货单
    // const nameList = [...leadsNameList, ...clientNameList, ...opNameList, ...prdNameList, ...contractNameList];
    const nameObj = {
      1: leadsNameList,
      2: clientNameList,
      3: opNameList,
      4: prdNameList,
      6: psNameList,
      7: [],
      8: contractNameList,
      9: [],
      10: [],
      11: [],
      12: [],
      13: returnOrderNameList
    };
    if (props.objId >= 200) {
      nameObj[props.objId] = ['chargePerson', 'createUser', 'updateUser', 'status'];
    }
    if (k === 'companyName') {
      tmp = { ...colType, fixed: 'left', width: 250 };
    } else if (nameObj[props.objId]?.indexOf(k) > -1) {
      tmp = { ...colType, slotName: k, width: 160 };
    } else if (k === 'followDetail' || k === 'industry' || k === 'city') {
      tmp = { ...colType, width: 220, render };
    } else if (k === 'mobile') {
      tmp = { ...colType, width: 140, render };
    } else {
      tmp = { ...colType, width, render };
    }
    if (tmp.dataIndex === 'qccId') {
      console.log(369, tmp);
    }
    return tmp;
  });
};
// 弹窗表格
const { tProps, setTProps, tPropsEvent, setLoadListParams, loadTList } = useXlTable(publicService.getListByEntityId.bind(publicService));

// 表格的属性和事件
const tableObj = reactive({
  attr: {
    rowSelection: props.multiple ? { type: 'checkbox', showCheckedAll: true } : { type: 'radio' }
  },
  ev: {}
});
// 设置属性
setTProps({
  ...tableObj.attr
});

// :row-selection="userInfo?.roles?.indexOf('001001011') === -1 ? null : rowSelection" row-key="id" v-model:selectedKeys="leadsIDs" @select="xlUseSelect" @selectAll="xlUseSelectAll"

const ids = ref([]);
const openDialog = async () => {
  if (props.disabled) return;
  try {
    ids.value = props.modelValue && props.multiple ? props.modelValue : [];
    columns.value = [];
    tableLoading.value = true;
    await getFields({ id: props.objId });
    tableLoading.value = false;
    visible.value = true;
    if (props.objId >= 200 && enableList.value.length > 0) {
      enableList.value.map((v) => {
        //兼容自定义对象，动态获取主字段
        if (v?.mainField) {
          objEnums[props.objId] = v?.fieldKey || 'name';
        }
      });
    }
    columns.value = getColumns(enableList.value);
    columns.value = [...columns.value, { dataIndex: 'search' }];
    let conditions = [];
    if (props.objId == 2 && props.qccId) {
      conditions = [{ fieldType: 0, fieldValue: props.qccId, type: 1, fieldKey: 'qccId' }];
    }
    setLoadListParams({
      isAll: false,
      entity: props.objId,
      customerId: props.customerId || undefined,
      conditions,
      name: undefined
    });
    await loadTList(1);
    console.log('转换后的表头列表', columns.value);
    emits('update:modelValue', props.multiple ? [] : ' ');
    // emits('update:modelValue', props.multiple ? [] : props.modelValue? props.modelValue: ' ');
    // emits('change', '');
  } catch (e) {
    tableLoading.value = false;
    visible.value = false;
    // console.log(405, e);
    // e?.message !== 'canceled' && Message.error(e?.message || e?.statusText || '获取数据失败');
  }
};

// 搜索
const getSerachData = (v) => {
  const val = v?.search?.val;
  const id = props.objId;
  const n = objEnums[id] || 'name';
  let conditions = [];
  const qccid = { fieldType: 0, fieldValue: props.qccId, type: 1, fieldKey: 'qccId' };
  if (props.objId == 2 && props.qccId) {
    conditions = [{ ...qccid }];
  }
  if (val) {
    const name = { fieldType: 0, fieldValue: val, type: 1, fieldKey: n };
    conditions = [{ ...name }];
    if (props.objId == 2 && props.qccId) {
      conditions = [{ ...name }, { ...qccid }];
    }
    setLoadListParams({ conditions, name: val || undefined });
  } else {
    setLoadListParams({ conditions, name: undefined });
  }

  loadTList(1);
};

// 表格选择
const xlTableSelect = (v) => {
  console.log(232, v);
  ids.value = v;
  // selectVal.value = props.multiple ? ids.value : ids.value?.[0];
  // console.log(485, props.modelValue)
  // emits('update:modelValue', props.modelValue || selectVal.value);
};
// 弹窗确定
const handleOk = async (done) => {
  console.log(240, done);
  if (!ids.value?.length) {
    Message.warning('至少选择一项数据');
    return false;
  }
  selectVal.value = props.multiple ? ids.value : ids.value?.[0];
  let item = tProps.value.data.filter((el) => ids.value.indexOf(el.id) > -1);
  item = item.map((el) => {
    el[`_name`] = el[objEnums[props.objId]];
    return el;
  });
  emits('update:modelValue', selectVal.value);
  emits('change', selectVal.value, item);
  emits('update:selectedItem', props.multiple ? item : item?.[0]);
};
// 弹窗取消
const cancelModal = () => {
  console.log(509, props.modelValue);
  // emits('update:modelValue', props.modelValue);
  // emits('update:modelValue', '');
  // emits('change', undefined);
  // emits('update:selectedItem', props.multiple ? [] : {});
};
// watch 检测 customerId变化
watch(
  () => props.customerId,
  () => {
    handleSearch();
  }
);
// 加载
onMounted(async () => {
  // await getPrimaryByEntity()
  await getObjectName();
  await handleSearch();
});
// const getPrimaryByEntity = async () => {
//   // options.value = []
//   try{
//     const params = {
//       isAll: false,
//       entity: props.objId,
//       conditions: []
//     }
//     const res = await publicService.getPrimaryByEntity(params)
//     if(!res.error){
//       // options.value = res.result
//     }
//   }catch(e){
//     console.log(e)
//   }
// }
const objectName = ref('');
const getObjectName = async () => {
  try {
    const res = await setService.getSysObjEnumList({ entityType: props.objId });
    if (!res.error) {
      objectName.value = res.result?.entityName;
    }
  } catch (e) {
    console.log(e);
  }
};
//批量转移--全选
const xlUseSelectAll = (checked) => {
  console.log(718, checked, options.value);
  // selectedRowKeys.value=[]
};
const clearHandle = () => {
  selectVal.value = props.multiple ? [] : '';
};
watchEffect(() => {
  selectVal.value = props.multiple && props.modelValue && props.modelValue !== '' ? props.modelValue?.map((el) => (el != '' && Number(el)) || []) : Number(props.modelValue) || '';
});
</script>
<style scoped lang="less">
@import './xl-find-obj.less';
</style>
